import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-read_card",
  "use": "icon-read_card-usage",
  "viewBox": "0 0 1132 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1132 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-read_card\"><path d=\"M1047.324 0H84.918C38.1 0 0 41.327 0 92.165v223.278c0 50.837 38.1 92.164 84.918 92.164h96.24V328.35h-96.24a14.323 14.323 0 0 1-5.661-12.907V92.165a14.38 14.38 0 0 1 5.661-12.908h962.406a14.323 14.323 0 0 1 5.661 12.908v223.278a14.38 14.38 0 0 1-5.66 12.907h-96.241v79.257h96.24c46.818 0 84.918-41.327 84.918-92.164V92.165c0-50.838-38.1-92.165-84.918-92.165z\" p-id=\"9703\" /><path d=\"M990.712 203.124a39.628 39.628 0 0 0-39.628-39.628H181.159a39.628 39.628 0 0 0 0 79.257h50.95v724.635A56.612 56.612 0 0 0 288.723 1024H843.52a56.612 56.612 0 0 0 56.612-56.612V242.753h50.95a39.628 39.628 0 0 0 39.63-39.629zM588.766 944.743h-277.4v-701.99h277.4z m232.11 0h-141.53v-701.99h141.53z\" p-id=\"9704\" /><path d=\"M407.494 655.285h79.257v181.16h-79.257z\" p-id=\"9705\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/read_card.svg
// module id = VO3f
// module chunks = 215